// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { AbstractModuleUi } from '../_abstract/ui';
import { ImageRatio } from '../_contracts';
import { Countdown } from '../_components/Countdown';
import { ImageWithCaption } from '../_components/ImageWithCaption';
import { prepareImage } from '../_filters';
/**
 * Component capable of rendering the `HeadingCountdownModule`'s contents.
 *
 * @author Adrian Gajos <adrian.gajos@movecloser.pl>
 */
let HeadingCountdownModuleUi = class HeadingCountdownModuleUi extends AbstractModuleUi {
    constructor() {
        super(...arguments);
        /**
         * The image to render.
         */
        this.image = null;
    }
    /**
     * Is external link set?
     */
    get hasExternalLink() {
        return !!this.module.content.externalLink;
    }
    /**
     * Get the image ratio to use
     */
    get _imageRatio() {
        if (typeof this.module.content.imageRatio === 'undefined') {
            return ImageRatio.Original;
        }
        return this.module.content.imageRatio;
    }
    /**
     * Fetch related image
     */
    async fetchRelated() {
        if (!this.module.content.useImage) {
            return;
        }
        let imageFile = null;
        if (typeof this.module.content.image === 'object' &&
            this.module.content.image !== null &&
            Number.isInteger(this.module.content.image.value)) {
            try {
                imageFile = this.relatedService.resolveSync(this.module.content.image, {});
                if (imageFile) {
                    this.image = prepareImage(imageFile, this._imageRatio, undefined, false);
                }
                this.onReady();
            }
            catch (e) {
                this.onError(e);
            }
        }
        else {
            this.onError();
        }
    }
};
HeadingCountdownModuleUi = __decorate([
    Component({
        name: 'HeadingCountdownModuleUi',
        components: {
            Countdown,
            ImageWithCaption
        },
        async created() {
            if (this.module.content.useImage && this.module.content.image) {
                await this.fetchRelated();
            }
        },
        template: `
    <component
      v-if="module.content.showCountdown && module.content.countdownTarget"
      :is="hasExternalLink ? 'a' : 'div'"
      class="heading-countdown-module"
      :class="{ 'heading-countdown-module--link': hasExternalLink, [moduleColoredClass]: true }"
      :style="{ backgroundColor: customColor }"
      v-bind="hasExternalLink ? { href: module.content.externalLink, target: '_blank', rel: 'noopener noreferrer' } : {}"
    >
      <template v-if="module.content.useAsAd">
        <span class="heading-countdown-module__ad-label">{{ $t('_.ad') }}</span>
      </template>

      <component :is="'h' + module.content.level" class="heading-countdown-module__title">
        <div v-if="module.content.useImage && image" class="heading-countdown-module__image">
          <ImageWithCaption :image="image" :hideDescription="true" :hideAuthor="true" :isLazy="false"/>
        </div>
        <span v-else>
          {{ module.content.text }}
        </span>

        <Countdown
          v-if="module.content.showCountdown"
          :prefix="module.content.countdownPrefix"
          :target="module.content.countdownTarget"
          :textColor="module.content.countdownTextColor"
          :boxColor="module.content.countdownBoxColor"
        />
      </component>
    </component>
  `
    })
], HeadingCountdownModuleUi);
export { HeadingCountdownModuleUi };
